export type ReferenceFormat = 'mc1' | 'northAmerican'

export interface DetectedReference {
  value: string
  format: ReferenceFormat
  formatLabel: string
  source: 'subject' | 'body'
}

interface ReferencePattern {
  pattern: RegExp
  format: ReferenceFormat
  formatLabel: string
}

const REFERENCE_PATTERNS: ReferencePattern[] = [
  {
    // MC1: 3 letters + dot + 6 digits (e.g., MUK.789043). Lookahead/lookbehind
    // instead of \b so underscore prefixes/suffixes still work (\b fails because
    // _ is a word character).
    pattern: /(?<![A-Za-z0-9])([A-Za-z]{3}\.\d{6})(?![A-Za-z0-9])/g,
    format: 'mc1',
    formatLabel: 'MC1 Reference',
  },
  {
    // North American: 3 digits + dot + 6 digits (e.g., 123.456789).
    pattern: /(?<![A-Za-z0-9])(\d{3}\.\d{6})(?![A-Za-z0-9])/g,
    format: 'northAmerican',
    formatLabel: 'North American Reference',
  },
]

const REPLY_PREFIX_PATTERN = /^(RE|FW|FWD)\s*:/i

export function isReplyOrForward(subject: string): boolean {
  return REPLY_PREFIX_PATTERN.test(subject)
}

/**
 * Extracts the first claim reference from the email subject only.
 * MC1 pattern is tried before North American.
 * Returns null if no reference is found.
 */
export function extractClaimReference(subject: string): DetectedReference | null {
  for (const { pattern, format, formatLabel } of REFERENCE_PATTERNS) {
    pattern.lastIndex = 0
    const match = pattern.exec(subject)
    if (match) {
      return { value: match[1].toUpperCase(), format, formatLabel, source: 'subject' }
    }
  }

  return null
}
